import useFormatPrice from '../../Hooks/use-format-price';
import useLocale from '../../Hooks/use-locale';
import useTypeSafeLocalize from '../../Hooks/use-type-safe-localize';
import localizations from '../../localizations';
import { LocalizationCategory, ProductLocalization } from '../../localizations/types';
import { Row } from '../../SubComponents/Modals';
import { Text } from '../../SubComponents/Text';
import { formatDuration } from '../../Utils/utils';

interface BoatCountDurationSummaryProps {
  boatCount: number;
  duration: number;
  price: number | undefined;
  textColor?: string;
}

const BoatCountDurationSummary = (props: BoatCountDurationSummaryProps) => {
  const localize = useTypeSafeLocalize();
  const { languageAsEnum } = useLocale();
  const localization = localizations[languageAsEnum];
  const formatPrice = useFormatPrice();

  return (
    <Row justifyContent="space-between" mb="2">
      <Text color={props.textColor ? props.textColor : '#fff'}>
        {props.boatCount}{' '}
        {props.boatCount === 1
          ? localize(LocalizationCategory.product, ProductLocalization.boat)
          : localize(LocalizationCategory.product, ProductLocalization.boats)}{' '}
        • {formatDuration(props.duration, { localization })}
      </Text>

      <Text color={props.textColor ? props.textColor : '#fff'}>
        {props.price || props.price === 0 ? formatPrice(props.price) : '-'}
      </Text>
    </Row>
  );
};

export default BoatCountDurationSummary;
